export default __webpack_public_path__ + "static/media/formations.c50b6fee.gif";